import { render, staticRenderFns } from "./CredenciamentoRecursoContrarrazaoTabela.vue?vue&type=template&id=8967fdc0&scoped=true"
import script from "./CredenciamentoRecursoContrarrazaoTabela.vue?vue&type=script&lang=js"
export * from "./CredenciamentoRecursoContrarrazaoTabela.vue?vue&type=script&lang=js"
import style0 from "./CredenciamentoRecursoContrarrazaoTabela.vue?vue&type=style&index=0&id=8967fdc0&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8967fdc0",
  null
  
)

export default component.exports